const StoreSkeleton = () => {
    return (
        <div className="storeItem">
            <div className="skeleton" style={{ height: 180, width: "100%", marginBottom: 10 }} />
            {/* <div className="skeleton" style={{ height: 40, width: 40, borderRadius: "50%", margin: "10px auto" }} /> */}
            <div className="skeleton" style={{ height: 18, width: "60%", margin: "10px auto" }} />
        </div>
    );
};

export default StoreSkeleton;
